// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ImageGallery-img-area[data-v-65276112]{padding:10px;display:flex;flex-wrap:wrap;justify-content:center}.ImageGallery-img-area img[data-v-65276112]{max-height:150px;padding:5px;cursor:pointer}@media only screen and (max-width:900px){.ImageGallery-img-area[data-v-65276112]{width:calc(100% - 10px);overflow:auto;max-height:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
